import { configureStore, createListenerMiddleware, isAnyOf } from "@reduxjs/toolkit"
import { apiSlice } from "./api/apiSlice"
import authReducer, { logOut, setCredentials } from '../features/auth/authSlice'
import botResponseReducer from "../features/v2/streaming/botResponseSlice"
import uiReducer from './uiSlice'

// The API cache belongs to whoever was signed in (#307). It survived logout, so the next
// account's arg-identical queries (quiz products, stats, lists) were served the previous
// account's data — on a shared store iPad, someone else's. One listener covers every path:
// the logout button, the token-refresh failures in apiSlice, and a sign-in as a different
// user without logging out (a token refresh for the same user keeps the cache).
const sessionListener = createListenerMiddleware()
sessionListener.startListening({
    matcher: isAnyOf(logOut, setCredentials),
    effect: (action, api) => {
        const before = api.getOriginalState().auth.user?.id
        if (logOut.match(action) || before !== action.payload?.user?.id) {
            api.dispatch(apiSlice.util.resetApiState())
        }
    },
})

export const store = configureStore({
    reducer: {
        [apiSlice.reducerPath]: apiSlice.reducer,
        auth: authReducer,
        botResponse: botResponseReducer,
        ui: uiReducer,
    },
    middleware: getDefaultMiddleware =>
        getDefaultMiddleware().prepend(sessionListener.middleware).concat(apiSlice.middleware),
    devTools: true
})
